import { useMemo, useState } from 'react'
import { toast } from 'react-toastify'

import { useAppContext, useAppStore, useAuthContext } from '@/hooks'
import { BatchUnlockModal } from '@/pages/User/pages/Home/components/TreePanel/components/BatchUnlockModal'

import { BatchEditModal } from './BatchEditModal'
import { useBatchEditContext } from './context/BatchEditContext'
import { ActionTypeEnum } from './context/types'

export const BatchEditUnlock = () => {
	const { t } = useAppContext()
	const [proceed, setProceed] = useState(false)
	const loggedUserId = useAppStore((state) => state.auth.user?.id)
	const auth = useAuthContext()
	const canForceUnlock = useMemo(() => auth.canForceUnlock(), [auth])

	const {
		state: { selectedNodes, selectedStructures, onClose },
		dispatch: dispatchContext,
	} = useBatchEditContext()

	const lockedByOthers = useMemo(
		() =>
			selectedStructures.filter(
				(node) => node.lockTime && node.lockUserId !== loggedUserId,
			),
		[loggedUserId, selectedStructures],
	)

	const allUnlocked = lockedByOthers.length === 0

	const handleUnlockSuccess = () => {
		// Set flag to skip lock check since we just force unlocked
		dispatchContext({
			type: ActionTypeEnum.SET,
			state: { skipLockCheck: true },
		})
		setProceed(true)
	}

	const handleSkip = (unlockedNodeIds: number[]) => {
		if (unlockedNodeIds.length === 0) {
			toast.warning(t('NO_ELEMENTS_TO_EDIT'))
			onClose()
			return
		}

		dispatchContext({
			type: ActionTypeEnum.SET,
			state: {
				selectedNodes: selectedNodes.filter((nodeId) =>
					unlockedNodeIds.includes(nodeId),
				),
			},
		})
		setProceed(true)
	}

	if (allUnlocked || proceed) {
		return <BatchEditModal />
	}

	return (
		<BatchUnlockModal
			structures={selectedStructures}
			onClose={onClose}
			onUnlockSuccess={handleUnlockSuccess}
			allowSkip={!canForceUnlock}
			onSkip={handleSkip}
			context="batchEdit"
		/>
	)
}
